// import React from "react";
// import ReactApexChart from "react-apexcharts";
// import { Box, Typography, Card } from "@mui/material";

// const OrdersStatusChart = () => {
//   const data = {
//     labels: [
//       "confirmed",
//       "packed",
//       "shipped",
//       "out-for-delivery",
//       "delivered",
//       "cancelled",
//       "returned"
//     ],
//     values: [98, 11, 4, 0, 0, 16, 2],
//     colors: [
//       "#3B82F6", // Blue - confirmed
//       "#F59E0B", // Orange - packed
//       "#8B5CF6", // Purple - shipped
//       "#06B6D4", // Cyan - out-for-delivery
//       "#22C55E", // Green - delivered
//       "#EF4444", // Red - cancelled
//       "#9CA3AF" // Gray - returned
//     ]
//   };

//   const totalOrders = data.values.reduce((a, b) => a + b, 0);

//   const options = {
//     chart: {
//       type: "donut"
//     },
//     colors: data.colors,
//     labels: data.labels,
//     legend: {
//       position: "bottom",
//       fontSize: "13px",
//       markers: { radius: 12 }
//     },
//     dataLabels: {
//       enabled: true,
//       formatter: val => `${val.toFixed(1)}%`,
//       style: {
//         fontSize: "12px",
//         fontWeight: 600
//       }
//     },
//     tooltip: {
//       y: {
//         formatter: val => `${val} orders`
//       }
//     },
//     plotOptions: {
//       pie: {
//         donut: {
//           size: "70%",
//           labels: {
//             show: true,
//             total: {
//               show: true,
//               label: "Total Orders",
//               fontSize: "14px",
//               fontWeight: 600,
//               color: "#111",
//               formatter: () => totalOrders
//             }
//           }
//         }
//       }
//     },
//     stroke: {
//       width: 2,
//       colors: ["#fff"]
//     }
//   };

//   const series = data.values;

//   return (
//     <Card
//       sx={{
//         p: 3,
//         borderRadius: 4,
//         boxShadow: 3,
//         bgcolor: "background.paper",
//         textAlign: "center"
//       }}
//     >
//       <Typography
//         variant="h6"
//         sx={{ mb: 2, fontWeight: 600, fontFamily: "Mulish, sans-serif" }}
//       >
//         Orders by Status
//       </Typography>

//       <Box sx={{ display: "flex", justifyContent: "center" }}>
//         <ReactApexChart
//           options={options}
//           series={series}
//           type="donut"
//           height={360}
//           width={360}
//         />
//       </Box>
//     </Card>
//   );
// };

// export default OrdersStatusChart;

import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, Card, CircularProgress, Alert } from "@mui/material";
import { getData } from "../Webservice/Webservice";

const OrdersStatusChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData(
          "dashboard/chart/order-by-status",
          null,
          token
        );

        if (data && data.success && data.chartData) {
          setChartData(data);
        } else {
          throw new Error("Invalid chart data response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load orders status chart data");
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Card
        sx={{
          p: 3,
          borderRadius: 4,
          boxShadow: 3,
          bgcolor: "background.paper",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 400
        }}
      >
        <CircularProgress />
      </Card>
    );
  }

  // Show error state
  if (error) {
    return (
      <Card
        sx={{
          p: 3,
          borderRadius: 4,
          boxShadow: 3,
          bgcolor: "background.paper"
        }}
      >
        <Alert severity="error">
          {error}
        </Alert>
      </Card>
    );
  }

  // Show chart when data is available
  if (!chartData) {
    return null;
  }

  const { labels, datasets } = chartData.chartData;
  const values = datasets[0].data;
  const colors = datasets[0].backgroundColor;

  const totalOrders = values.reduce((a, b) => a + b, 0);

  const options = {
    chart: {
      type: "donut"
    },
    colors: colors,
    labels: labels,
    legend: {
      position: "bottom",
      fontSize: "13px",
      markers: { radius: 12 }
    },
    dataLabels: {
      enabled: true,
      formatter: val => `${val.toFixed(1)}%`,
      style: {
        fontSize: "12px",
        fontWeight: 600
      }
    },
    tooltip: {
      y: {
        formatter: val => `${val} orders`
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total Orders",
              fontSize: "14px",
              fontWeight: 600,
              color: "#111",
              formatter: () => totalOrders
            }
          }
        }
      }
    },
    stroke: {
      width: 2,
      colors: ["#fff"]
    }
  };

  const series = values;

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 4,
        boxShadow: 3,
        bgcolor: "background.paper",
        textAlign: "center"
      }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 2, fontWeight: 600, fontFamily: "Mulish, sans-serif" }}
      >
        Orders by Status
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={360}
          width={360}
        />
      </Box>
    </Card>
  );
};

export default OrdersStatusChart;
